import SERVICE from './serviceName'

// DOCS: https://fhconfluence.churchofjesuschrist.org/pages/viewpage.action?spaceKey=Product&title=Artifact+Store+Documentation

export default function getPortraitUrl(cisId, extension = 'thumb200s') {
  return `${SERVICE}/user-portrait/${cisId}/${extension}`
}
